import { ZodOptional, ZodType } from 'zod';

export const isOptional = (schema: ZodType): boolean => {
  // Handle ZodOptional directly
  if (schema instanceof ZodOptional) {
    return true;
  }

  // Use the internal _def.type to determine schema type
  const schemaAny = schema as any; // eslint-disable-line @typescript-eslint/no-explicit-any

  // Check for optional type
  if (schemaAny._def?.type === 'optional') {
    return true;
  }

  // For pipe schemas, check the output schema
  if (schemaAny._def?.type === 'pipe' && schemaAny._def.out) {
    return isOptional(schemaAny._def.out);
  }

  return false;
};

export const isRequired = (schema: ZodType): boolean => {
  return !isOptional(schema);
};
